import React from 'react'
import { useNavigate } from "react-router-dom";
import PageHeader from "../common/ui/pageheader";

export default function AddDisptachheading() {
 const navigate = useNavigate();
  const isLoadingAutoFileNumber = false; // or from props/state

  const handleAddInbondClick = () => {
    // do your navigation or logic here
    navigate("/dispatch/add-dispatch");
  };

  return (
    <PageHeader
      title="Dispatch"
      subtitle="Here you can record dispatch materials."
      buttonText="Add Dispatch" // added text
      onButtonClick={handleAddInbondClick}
      disabled={isLoadingAutoFileNumber}
    />
  );
}
